import { getCookie } from "./cookies";

export class OfficeTracker {
    private static cookieName: string = 'ifbi-personalization';
    private params: URLSearchParams;

    constructor() {
        this.params = new URLSearchParams(getCookie(OfficeTracker.cookieName));
    }

    public get agent(): string {
        return this.params.get('agent') || null;
    }

    public get office(): string {
        return this.params.get('office') || null;
    }

    public get hasCustomHeader(): boolean {
        return this.params.get('customHeader') === 'True';
    }
}